export const VERIDAS_TOKEN_PARAM = 'veridastoken';

export enum VERIDAS_CODES {
    ERROR = 'ProcessError',
    COMPLETED = 'ProcessCompleted'
}
